export default __webpack_public_path__ + "static/media/cop-sec-1.881f1c71.jpeg";